var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H8C6.89761 6 6 6.89675 6 8V10.7999H22V8C22 6.89675 21.1024 6 20 6ZM17.6 9.20007H16.8001C16.5793 9.20007 16.4001 9.0208 16.4001 8.80011C16.4001 8.57926 16.5794 8.40014 16.8001 8.40014H17.6C17.8209 8.40014 18 8.57941 18 8.80011C18 9.02081 17.8207 9.20007 17.6 9.20007ZM20 9.20007H19.2001C18.9792 9.20007 18.8001 9.0208 18.8001 8.80011C18.8001 8.57926 18.9794 8.40014 19.2001 8.40014H20C20.2208 8.40014 20.4 8.57941 20.4 8.80011C20.4 9.02081 20.2208 9.20007 20 9.20007Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20C6 21.1032 6.89761 22 8 22H20C21.1024 22 22 21.1032 22 20V11.6H6V20Z",
    fill: "#8DADD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/App.47d1c6cb08e536c906b6826b0d1a9dba.svg";
export { ForwardRef as ReactComponent };